export const getAgeYears = (rawAge: any): number | null => {
    if (rawAge === null || rawAge === undefined) return null;

    let ageYears = 0;
    if (typeof rawAge === "string") {
        const lowerAge = rawAge.toLowerCase();
        const yearMatch = lowerAge.match(/(\d+(?:[.,]\d+)?)\s*yıl/);
        if (yearMatch) {
            ageYears = Number(yearMatch[1].replace(",", "."));
        } else if (lowerAge.includes("ay") || lowerAge.includes("gün")) {
            ageYears = 0;
        } else {
            // Try to parse it as a pure number if no year/month unit is present
            const num = Number(rawAge.replace(",", "."));
            if (!isNaN(num)) {
                ageYears = num;
            } else {
                return null;
            }
        }
    } else if (typeof rawAge === "number") {
        ageYears = rawAge;
    } else {
        return null;
    }
    return ageYears;
};

export const isPatientUnder18 = (rawAge: any): boolean => {
    const age = getAgeYears(rawAge);
    if (age === null) return true; // Default to showing if age is unknown? Or false? Usually true to be safe.
    return age < 18;
};

export const isPatientNewborn = (rawAge: any): boolean => {
    const age = getAgeYears(rawAge);
    if (age === null) return true;
    return age < 1;
};
